import { Component, OnChanges, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { CCRPSMToken, CCRPStatusMonitoring, CCRPDayToken, DailyTokenItem, DailyToken } from '../../../shared/misc-classes';
import { DataService } from '../../../shared/dataservice.service';
import { GenService } from '../../../shared/gen-ser.service';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { OutletContext } from '@angular/router';


@Component({
  selector: 'app-ccrp-day-view',
  templateUrl: './ccrp-day-view.component.html',
  styleUrls: ['./ccrp-day-view.component.css']
})
export class CcrpDayViewComponent implements OnChanges {
  @Input() currMonthDtObj:Date;
  @Input() datatables:CCRPStatusMonitoring;  
  ccrpDayTokenObj:CCRPDayToken;
  editRow:CCRPSMToken;
  prevStatusValue:string='';
  closedFlag:boolean = false;
  prevClosedTime:number;

  editToken:string = '';
  editHeader:string = '';
  editText:string = '';
  editType:string = '';
  editDate:Date = new Date();
  editParam1:any;
  editParam2:any;
  editSubType:string = '';
  @Input() mId:string;
  @Output() changesFlag = new EventEmitter();

  CopyCCRPDayTokenObj:Array<CCRPSMToken>=[];
  copyDataObj:CCRPStatusMonitoring;
  copySelDate:Date = new Date();

  allData:CCRPStatusMonitoring;
  
  @ViewChild('childModal') public childModal:ModalDirective;  
  @ViewChild('copyModal') public copyModal:ModalDirective;

  constructor(private _dataService:DataService) { }
 

  ngOnChanges() {
    // this.loadAllData();
    this.loadDateData();
  }

  // loadAllData(){
  //   this._dataService.loadCCRPAllData().subscribe((_cstInspPlan:any) => {
  //     if(_cstInspPlan!=null){
  //     this.allData = _cstInspPlan;
  //     }
  //   });
  // }
  public showChildModal(_editToken:string,_param1:any,_param2:any):void {
    switch(_editToken){
      case "rowedit":
      this.editRow = _param1.cloneSelf();
      if(this.editRow.status == 'closed'){
        this.closedFlag = true;
      }
      else{
        this.closedFlag = false
      }
      this.editType = _editToken;
      this.prevStatusValue = this.editRow.status;
      this.editHeader = "Edit CCRP Status (" + this.formatHeaderDate(this.ccrpDayTokenObj.selDate) +")";
      break; 
      case "newrow":
        this.editRow = new CCRPSMToken(null,null,null,null,null,this.currMonthDtObj.getTime(),null,null,(new Date()).getTime())
        this.editType = _editToken;
        this.closedFlag = false;
        this.editHeader = "Add CCRP Status (" + this.formatHeaderDate(this.ccrpDayTokenObj.selDate) +")";
      break;
      case "date":
        this.editDate = this.datatables.monthDate;
        this.editType = 'date';
        this.editHeader = "Edit Date";
      break;
      case "text":
        let name:string = _param1;
        this.editSubType = _param2;
        if(this.editSubType == 'tillDateRaisedCCRP'){
          this.editText = this.ccrpDayTokenObj.tillDateRaisedCCRP;
        }
        else if(this.editSubType == 'tillDateClosedCCRP'){
          this.editText = this.ccrpDayTokenObj.tillDateClosedCCRP;
        }
        else if(this.editSubType == 'openCCRPOnDate'){
          this.editText = this.ccrpDayTokenObj.openCCRPOnDate;
        }
        else if(this.editSubType == 'CCRPOpenForMaterials'){
          this.editText = this.ccrpDayTokenObj.CCRPOpenForMaterials;
        }
        else if(this.editSubType == 'CCRPOpenServiceEng'){
          this.editText = this.ccrpDayTokenObj.CCRPOpenServiceEng;
        }
        else if(this.editSubType == 'CCRPWaitingForClosure'){
          this.editText = this.ccrpDayTokenObj.CCRPWaitingForClosure;
        }
        
        this.editType = 'text';
        this.editHeader = "Edit "+_param1;
      break;
    }
    this.editParam1 = _param1;
    this.editParam2 = _param2;
    this.editToken = _editToken;
   // this.areChangesMade= true;
    this.childModal.show();
  }
  statusChanged(editRow,status){
    if(status=='closed'){
      //this.editRow
    }
  }
  countCCRPs(type){
    if(type == 'material'){

    }
  }
  dataEdited(){
    switch(this.editToken){
      case "rowedit":
        this.editParam1.reason = this.editRow.reason;
        this.editParam1.targetDateNum = this.editRow.targetDateNum;       
        this.editParam1.materialDesc = this.editRow.materialDesc;
        this.editParam1.respPrsn = this.editRow.respPrsn;
        this.editParam1.status = this.editRow.status;
        this.editParam1.ccrpNo = this.editRow.ccrpNo;
        this.editParam1.customer = this.editRow.customer;
        if(this.editRow.status == 'closed' && this.prevStatusValue == 'in process'){
          this.editParam1.closedDateNum = new Date().getTime();
        }
        else if(this.editRow.status == 'closed' && this.prevStatusValue == 'closed'){
          this.editParam1.closedDateNum = this.prevClosedTime;
        }
        else {
          this.editParam1.closedDateNum = null;
        }
        this.editParam1.createdDate = this.editRow.createdDate;
      break;
      case "newrow":
        this.datatables.addDateToken(new Date(this.currMonthDtObj),this.ccrpDayTokenObj.tillDateRaisedCCRP,this.ccrpDayTokenObj.tillDateClosedCCRP,this.ccrpDayTokenObj.openCCRPOnDate,this.ccrpDayTokenObj.CCRPOpenForMaterials,this.ccrpDayTokenObj.CCRPOpenServiceEng,this.ccrpDayTokenObj.CCRPWaitingForClosure,new CCRPSMToken(this.editRow.ccrpNo,this.editRow.customer,this.editRow.reason,this.editRow.materialDesc,this.editRow.respPrsn,this.editRow.targetDateNum,this.editRow.status,this.editRow.closedDateNum,this.editRow.createdDate));
        this.prevStatusValue = this.editRow.status;
      break;
      case "date":
        this.datatables.monthDate = this.editDate;
        this.currMonthDtObj = this.editDate;
        //this.loadMonthData();
      break;
      case "text":
        if(this.editSubType == 'tillDateRaisedCCRP'){
          this.ccrpDayTokenObj.tillDateRaisedCCRP = this.editText;
        }
        else if(this.editSubType == 'tillDateClosedCCRP'){
          this.ccrpDayTokenObj.tillDateClosedCCRP = this.editText;
        }
        else if(this.editSubType == 'openCCRPOnDate'){
          this.ccrpDayTokenObj.openCCRPOnDate = this.editText;
        }
        else if(this.editSubType == 'CCRPOpenForMaterials'){
          this.ccrpDayTokenObj.CCRPOpenForMaterials = this.editText;
        }
        else if(this.editSubType == 'CCRPOpenServiceEng'){
          this.ccrpDayTokenObj.CCRPOpenServiceEng = this.editText;
        }
        else if(this.editSubType == 'CCRPWaitingForClosure'){
          this.ccrpDayTokenObj.CCRPWaitingForClosure = this.editText;
        }
      break;
    }
    this.changesFlag.emit(true)
    this.hideChildModal();
  }
  public removeRecord( _tokenIndex:number) {
    this.ccrpDayTokenObj.removeToken(_tokenIndex);    
    this.changesFlag.emit(true)
  }
  public hideChildModal():void {
    this.childModal.hide();
  }

  public discardSaveData():void {
    this.childModal.hide();
  }

  public addNewProdRow(_newRowToken:string,_dayIndex:number){
    switch(_newRowToken){
      case "newrow":
        this.showChildModal(_newRowToken,null,null);
        // this.datatables.dayTokens[_dayIndex].push(new CCRPSMToken(null, null, null));
        // this.showChildModal(_newRowToken,_dayIndex,this.datatables.dayTokens[_dayIndex].length-1);
        this.editType = "newrow"
      break;
    }
  }

  formatHeaderDate(_date:Date):string{
    if (_date) {
      return GenService.getDateFormatStr(_date, "DD-MMM");
    }
    return '-';
  }
  prevDateSel():void{
    if(this.currMonthDtObj.getDate() > 1){
      this.currMonthDtObj.setDate(this.currMonthDtObj.getDate()-1);
      this.loadDateData();
      this.copySelDate.setDate(this.currMonthDtObj.getDate()-1);
    }
  }
  // prevCopyDateSel():void{
  //   this.copySelDate.setDate(this.copySelDate.getDate()-1);
  //   this.copyData();
  // }
  // nextCopyDateSel():void{
  //     this.copySelDate.setDate(this.copySelDate.getDate()+1);
  //     this.copyData();
  // }
  nextDateSel():void{
    var _tmpLastDayOfMonth:Date = new Date(this.currMonthDtObj.getFullYear(),this.currMonthDtObj.getMonth()+1,0);
    if(this.currMonthDtObj.getDate() < _tmpLastDayOfMonth.getDate()){
      this.currMonthDtObj.setDate(this.currMonthDtObj.getDate()+1);
      this.loadDateData();
      this.copySelDate.setDate(this.currMonthDtObj.getDate()-1);
    }
  }
  loadDateData():void{
    let _tmpDPHDayToken:CCRPDayToken = this.datatables.getDateToken(this.currMonthDtObj);
    if(_tmpDPHDayToken == null){
      this.datatables.addDateToken(this.currMonthDtObj,null,null,null,null,null,null);  
      _tmpDPHDayToken = this.datatables.getDateToken(this.currMonthDtObj);
    }
    this.ccrpDayTokenObj = _tmpDPHDayToken;
  }
  hasReadAccess(_pid:string){
    return this._dataService.hasReadAccess(this.mId,_pid);
  }
  hasEditAccess(_pid:string){
    return this._dataService.hasEditAccess(this.mId,_pid);
  }
  formatDate(_date:Date):string{
    if(_date){
      return GenService.getDateFormatStr(_date, "DD-mmm-YYYY");
    }
    return '-';
  }
  parseDate(dateString: string): Date {
    if (dateString) {
        return new Date(dateString);
    } else {
        return null;
    }
  }
  getData(option){
    if(option) return option
    return ''
  }
  getReason(id:string):string{
    if(id) return this._dataService.getCCRPReason(id)
    return ''
  }
  getStatus(id:string):string{
    if(id == "forwarded"){
      return "Forwarded";
    }
    if(id) return this._dataService.getCCRPStatus(id)
    return ''
  }
  getResponsiblePrsn(_prsn:string):string{
    if(_prsn) return this._dataService.getResponsiblePrsn(_prsn); 
    return ''
  }
  getCustomer(id:string):string{
    if(id) return this._dataService.getCustomerName(id)
    return ''
  }
  // dataCopied(){
  //   for(var i=0;i<this.CopyCCRPDayTokenObj.length;i++){
  //     this.CopyCCRPDayTokenObj[i].createdDate = (new Date()).getTime();
  //     this.ccrpDayTokenObj.addToken(this.CopyCCRPDayTokenObj[i])
  //   } 
  //   //this.areChangesMade = true;
  //   this.discardCopyData(); 
      
  // }
  // copyData(){
  //   this.copyDataObj=null;
  //   this._dataService.getCCRPCopyData(this.copySelDate).subscribe((_doc:CCRPStatusMonitoring) => {
  //     if(_doc.dayTokens.length>0){  
  //       this.copyDataObj = _doc;
  //       this.loadCopyDateData();
  //     }
  //     else{
  //       this.CopyCCRPDayTokenObj = [];
  //     }
  //   });
  //   this.copyModal.show();
  // }
  // hideCopyChildModal(){
  //   this.copyModal.hide()
  // }
  // discardCopyData(){    
  //   this.CopyCCRPDayTokenObj=[];
  //   this.hideCopyChildModal()
  // }
  // openCopyModal(){ 
  //   this.copySelDate = new Date(this.currMonthDtObj.getTime()) 
  //   this.copySelDate.setDate(this.copySelDate.getDate() - 1)
  //   this.copyData();
  // }
  // loadCopyDateData():void{
  //   this.CopyCCRPDayTokenObj = [];
  //   if(this.copyDataObj.dayTokens[0]){
  //     for(var i=0;i<this.copyDataObj.dayTokens[0].dateTokens.length;i++){
  //       let temp = this.copyDataObj.dayTokens[0].dateTokens[i];
  //       this.CopyCCRPDayTokenObj.push(new CCRPSMToken(temp.ccrpNo,temp.customer,temp.reason,temp.materialDesc,temp.respPrsn,temp.targetDateNum,temp.status,temp.closedDateNum,temp.createdDate))
  //     }
  //   }
  // }
  // formatCopyHeaderDate(_date:Date):string{
  //   if (_date) {
  //     return GenService.getDateFormatStr(_date, "DD-mmm-YYYY");
  //   }
  //   return '-';
  // }
}
